// extracted by mini-css-extract-plugin
export default {"h3":"FormsButton_h3__sFZL1","button":"FormsButton_button__9lKAC","background":"FormsButton_background__TfN0a"};